import axios from 'axios';
import detect400BadRequest from './detect400BadRequest';

const makeApiRequest = (type: string) => {
	interface APIResponse {
		data: any;
		error: any;
	}

	const http = axios.create({
		withCredentials: true,
	});

	const handleErrorResponse = (err: any): APIResponse => {
		const apiResponse: APIResponse = {
			data: null,
			error: null,
		};

		console.log('Error catched during api call,', err);

		if (!err || !err.response) {
			console.log('Error contained empty or no response,', err.response);
			apiResponse.error = { message: 'empty or no response', status: 500 };
		} else if (err.response.data && err.response.status && typeof err.response.data === 'object') {
			console.log('Error contained expected error response type,', err.response);
			apiResponse.error = err.response?.data;
			if (!apiResponse.error.status) {
				apiResponse.error.status = err.response.status;
			}
		} else if (typeof err.response.data === 'string' && detect400BadRequest(err.response.data)) {
			console.log('Error contained 400 - Bad Request unexpected error,', err.response);
			apiResponse.error = { message: err.response.data, status: 500 };
		} else {
			console.log('Error contained unexpected error response type,', err.response);
			apiResponse.error = { message: 'unexpected error response', status: 500 };
		}

		return apiResponse;
	};

	const makeRequest = async (method: 'post' | 'put' | 'get', url: string, body: any) => {
		const apiResponse: APIResponse = {
			data: null,
			error: null,
		};

		try {
			const { data } = await http[method](url, body);
			apiResponse.data = data;
		} catch (err: any) {
			return handleErrorResponse(err);
		}

		return apiResponse;
	};

	switch (type) {
		case 'POST':
			return (url: string, body: any) => makeRequest('post', url, body);
		case 'PUT':
			return (url: string, body: any) => makeRequest('put', url, body);
		case 'GET':
			return (url: string, body: any) => makeRequest('get', url, body);
		default:
			return (url: string, body: any) => makeRequest('get', url, body);
	}
};

export default makeApiRequest;
